<template>
  <section class="projects-section">
    <div class="container">
      <h2 class="section-heading">My Projects</h2>
      <div class="categories">
        <ul>
          <li><a :class="all? 'active': ''" @click="callAll"> All</a></li>
          <li><a :class="html? 'active': ''" @click="callHtml"> HTML/CSS</a></li>
          <li><a :class="js? 'active': ''" @click="callJs"> JavaScript</a></li>
          <li><a :class="vue? 'active': ''" @click="callVue"> Vue.js</a></li>
          <li><a :class="react? 'active': ''" @click="callReact">React.js</a></li>
        </ul>
      </div>
     <transition name="fade">
      <div class="projects" v-if="this.all">
        <div v-for="(project, index) in projects" :key="index" class="project">
          <img
            :src="require(`../../assets/imgs/${project.image}.jpg`)"
            :alt="project.type"
            class="skill-img"
          />

          <div class="content">
            <h3 class="title">{{ project.title }}</h3>
            <p class="description">{{ project.description }}</p>
            <ul class="hashtags">
              <li
                v-for="(hashtag, index) in project.hashTags"
                :key="index"
                class="hashtag"
              >
                #{{ hashtag.name }}
              </li>
            </ul>

            <div class="link-container">
              <a :href="project.githublink" target="_blank">Github</a>
              <a :href="project.liveWebsitelink" target="_blank">Live Preview</a>
            </div>
          </div>
        </div>
      </div>
     </transition>
      <transition name="fade">
        <div class="projects" v-if="this.html">
        <div v-for="(project, index) in projects.filter(project=>project.type=='html')" :key="index" class="project">
          <img
            :src="require(`../../assets/imgs/${project.image}.jpg`)"
            :alt="project.type"
            class="skill-img"
          />

          <div class="content">
            <h3 class="title">{{ project.title }}</h3>
            <p class="description">{{ project.description }}</p>
            <ul class="hashtags">
              <li
                v-for="(hashtag, index) in project.hashTags"
                :key="index"
                class="hashtag"
              >
                #{{ hashtag.name }}
              </li>
            </ul>

            <div class="link-container">
              <a :href="project.githublink" target="_blank">Github</a>
              <a :href="project.liveWebsitelink" target="_blank">Live Preview</a>
            </div>
          </div>
        </div>
      </div>
      </transition>
     <transition name="fade">
      <div class="projects" v-if="this.js">
        <div v-for="(project, index) in projects.filter(project=>project.type=='js')" :key="index" class="project">
          <img
            :src="require(`../../assets/imgs/${project.image}.jpg`)"
            :alt="project.type"
            class="skill-img"
          />

          <div class="content">
            <h3 class="title">{{ project.title }}</h3>
            <p class="description">{{ project.description }}</p>
            <ul class="hashtags">
              <li
                v-for="(hashtag, index) in project.hashTags"
                :key="index"
                class="hashtag"
              >
                #{{ hashtag.name }}
              </li>
            </ul>

            <div class="link-container">
              <a :href="project.githublink" target="_blank">Github</a>
              <a :href="project.liveWebsitelink" target="_blank">Live Preview</a>
            </div>
          </div>
        </div>
      </div>
     </transition>
     <transition name="fade">
      <div class="projects" v-if="this.vue">
        <div v-for="(project, index) in projects.filter(project=>project.type=='vue')" :key="index" class="project">
          <img
            :src="require(`../../assets/imgs/${project.image}.jpg`)"
            :alt="project.type"
            class="skill-img"
          />

          <div class="content">
            <h3 class="title">{{ project.title }}</h3>
            <p class="description">{{ project.description }}</p>
            <ul class="hashtags">
              <li
                v-for="(hashtag, index) in project.hashTags"
                :key="index"
                class="hashtag"
              >
                #{{ hashtag.name }}
              </li>
            </ul>

            <div class="link-container">
              <a :href="project.githublink" target="_blank">Github</a>
              <a :href="project.liveWebsitelink" target="_blank">Live Preview</a>
            </div>
          </div>
        </div>
      </div>
     </transition>
     <transition name="fade">
      <div class="projects" v-if="this.react">
        <div v-for="(project, index) in projects.filter(project=>project.type=='react')" :key="index" class="project">
          <img
            :src="require(`../../assets/imgs/${project.image}.jpg`)"
            :alt="project.type"
            class="skill-img"
          />

          <div class="content">
            <h3 class="title">{{ project.title }}</h3>
            <p class="description">{{ project.description }}</p>
            <ul class="hashtags">
              <li
                v-for="(hashtag, index) in project.hashTags"
                :key="index"
                class="hashtag"
              >
                #{{ hashtag.name }}
              </li>
            </ul>

            <div class="link-container">
              <a :href="project.githublink" target="_blank">Github</a>
              <a :href="project.liveWebsitelink" target="_blank">Live Preview</a>
            </div>
          </div>
        </div>
      </div>
     </transition>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    data() {
      return {
        all: true,
        html: false,
        js: false,
        vue: false,
        react: false,
      };
    },
    computed: {
      ...mapGetters(["projects"]),
    },
    methods: {
      callAll() {
        this.all = true;
        this.html = false;
        this.js = false;
        this.vue = false;
        this.react = false;
      },
      callHtml() {
        this.all = false;
        this.html = true;
        this.js = false;
        this.vue = false;
        this.react = false;
      },
      callJs() {
        this.all = false;
        this.html = false;
        this.js = true;
        this.vue = false;
        this.react = false;
      },  callVue() {
        this.all = false;
        this.html = false;
        this.js = false;
        this.vue = true;
        this.react = false;
      },
      callReact() {
        this.all = false;
        this.html = false;
        this.js = false;
        this.vue = false;
        this.react = true;
      }
    },
  };
</script>

<style scoped>
  .categories {
    width: 50vw;
    margin: 0 auto;
  }
  .categories ul {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }
  .categories ul li {
    list-style: none;
  }
  .categories ul li a {
    font-size: 1.5em;
    color: var(--color-secondary);
    cursor: pointer;
    border-bottom: 2px solid transparent;
  }

  .categories ul li a:hover,
  .categories ul li a.active {
    border-bottom: 2px solid var(--color-green);
  }
  .projects {
    margin-top: 60px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 40px;
    column-gap: 100px;
    justify-items: center;
  }
  .project {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 15px;
    transition: all 0.5s;
  }
  .project:hover {
    transform: translatey(10px);
  }
  .content {
    padding: 25px 30px;
    background: #f5f5f5;
    border-bottom-right-radius: 15px;
    border-bottom-left-radius: 15px;
  }
  .content .title {
    font-size: 1.5em;
    color: var(--color-green);
    margin-bottom: 10px;
  }
  .content .description {
    color: var(--color-primary);
    line-height: 175%;
    font-size: 1.1em;
    margin-bottom: 10px;
  }
  .content .hashtags {
    display: flex;
    gap: 15px;
  }
  .content .hashtags .hashtag {
    list-style: none;
    color: var(--color-green);
    font-size: 1.2em;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .link-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    gap: 30px;
    margin-top: 10px;
  }
  .link-container a {
    padding: 10px 30px;
    border-radius: 30px;
    background: var(--color-green);
    text-decoration: none;
    color: white;
    font-size: 1.1em;
    border: 2px solid transparent;
    transition: all 0.5s;
  }
  .link-container a:hover {
    color: var(--color-green);
    background: transparent;
    border: 2px solid var(--color-green);
  }

  .project img {
    width: 100%;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
  }

  @media only screen and (max-width: 767px) {
    .link-container a {
      padding: 10px 30px;
      border-radius: 30px;
      background: var(--color-green);
      text-decoration: none;
      color: white;
      font-size: 1em;
      border: 2px solid transparent;
      transition: all 0.5s;
    }
    .projects {
      grid-template-columns: repeat(1, 1fr);
    }
    .categories {
      width: 90%;
      margin: 0 auto;
    }
    .categories ul {
      flex-basis: 100%;
      flex-wrap: wrap;
      justify-content: center;
    }
    .categories ul li a {
      font-size: 1.3em;
      color: var(--color-secondary);
      cursor: pointer;
      border-bottom: 2px solid transparent;
    }
  }

  .fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
